import { application } from "./application"

import AutocompleteController from "./autocomplete_controller"
import DropdownController from "./dropdown_controller"
import HelloController from "./hello_controller"
import SidebarController from "./sidebar_controller"
import TabsController from "./tabs_controller"
import FormTabsController from "./form_tabs_controller"
import LabelCreatorController from "./label_creator_controller"
import DealerModalController from "./dealer_modal_controller"
import ConfirmationController from "./confirmation_controller"
import ValidationController from "./validation_controller"
import ThemeController from "./theme_controller"
import WaitlistDisplayController from "./waitlist_display_controller"

application.register("autocomplete", AutocompleteController)
application.register("dropdown", DropdownController)
application.register("hello", HelloController)
application.register("sidebar", SidebarController)
application.register("tabs", TabsController)
application.register("form-tabs", FormTabsController)
application.register("label-creator", LabelCreatorController)
application.register("dealer-modal", DealerModalController)
application.register("confirmation", ConfirmationController)
application.register("validation", ValidationController)
application.register("theme", ThemeController)
application.register("waitlist-display", WaitlistDisplayController)

import BottomSheetController from "./bottom_sheet_controller"
application.register("bottom-sheet", BottomSheetController)
